import { graphic } from "../Graphic";
import { Container, Matrix } from "pixi.js";
import { TYPES } from "../EntityManager";
import { Shape } from "../helpers/Shape";
import { Entity } from "./Entity";
import { GraphicItemService } from "./row/GraphicItemService";

export class EntityService {

    static enableCategories(categories = null, disableOther = true) {
        graphic.entityManager.forEach([TYPES.PIT, TYPES.ROW], entity => {
            if (categories === null) {
                entity.enable();
            } else if (categories.includes(parseInt(entity.category.id))) {
                entity.enable();
            } else if (disableOther) {
                entity.disable();
            }
        })
    }

    static upsertFromProps(type, itemsProps) {
        itemsProps.forEach(props => {
            if (!props) return;
            const entity = graphic.entityManager.get(type, props.id);
            if (entity) {
                entity.updateFromProps(props);
            } else {
                const entity = this.createFromProps(props);
                if (entity) {
                    entity.draw();
                    graphic.entityManager.push(type, entity);
                }
            }
        });
    }

    static createFromProps(props) {
        const { id } = props;
        const container = new Container();
        const matrix = new Matrix();

        if (props.transformationMatrix) {
            const { a, b, c, d, e, f } = props.transformationMatrix;
            matrix.set(a, b, c, d, e, f);

            container.transform.setFromMatrix(matrix);
            container.worldTransform.translate(e, f);
        }

        return { id, container }
    }

    static invalidateGraphicItem(graphicItem) {
        GraphicItemService.setGraphicItemColor(graphicItem, null, 0.15);

        graphicItem.status = Entity.GRAPHIC_STATE_DISABLED;
        const cross = Shape.createAbstractShape(
            [
                {x: -8, y: -8},
                {x: 8, y: 8},
                {x: -8, y: 8, move: true},
                {x: 8, y: -8},
            ],
            [3, 0x000000, 1]
        );
        cross.name = 'cross';
        graphicItem.cursor = 'pointer';
        graphicItem.addChild(cross);
    }

    static validateGraphicItem(graphicItem) {
        GraphicItemService.setGraphicItemColor(graphicItem, null, 1);

        graphicItem.status = Entity.GRAPHIC_STATE_FREE;
        graphicItem.children.forEach(child => {
            if (child.name === 'cross') graphicItem.removeChild(child)
        });
    }

    static overGraphicItem(graphicItem) {
        graphicItem.cacheAsBitmap = false;
        graphicItem.geometry.graphicsData[0].lineStyle.alpha = 1;
        graphicItem.geometry.graphicsData[0].lineStyle.width = 5;
        graphicItem.geometry.graphicsData[0].lineStyle.color = 0x000000;
        graphicItem.geometry.invalidate();
    }

    static outGraphicItem(graphicItem) {
        graphicItem.cacheAsBitmap = false;
        graphicItem.geometry.graphicsData[0].lineStyle.alpha = 0;
        graphicItem.geometry.graphicsData[0].lineStyle.width = 0;
        graphicItem.geometry.graphicsData[0].lineStyle.color = 0;
        graphicItem.geometry.invalidate();
        graphicItem.cacheAsBitmap = true;
    }
}